import React, { Component } from 'react';

import FormSettings from '../../../shared/constants/form-settings';
import EmailMessages from '../../../shared/constants/email-messages';

import SettingsTab from '../tab';
import ButtonsSection from '../sections/buttons';
import ConfirmationPageSection from '../sections/confirmation-page';

import classNames from 'classnames';

export default class PublicFormTab extends SettingsTab {
	static propTypes = {
		
	}

	constructor (props) {
		super(props);
	}
	
	render () {
		let { localization } = this.props;
		let classes = classNames({
			'hidden': !this.props.selected
		}, 'public-form')

		const formCollectsPayment = this.props.formData.collectPayment || false;
		const formCollectsSignature = this.props.formData.collectSignature || false;

		return (
			<section className={classes} key={this.props.customKey}>
				<div className='left column'>
					<ButtonsSection
						submitButtonLabel={this.coalesceProperty(FormSettings.SUBMIT_BUTTON_LABEL, null)}
						updateCallback={this.updateSetting}
						localization={localization}
					/>
				</div>
				<div className='right column'>
					<ConfirmationPageSection
						activeTab={this.coalesceProperty(FormSettings.CONFIRMATION_DESTINATION, 'thank_you_page')}
						confirmationLink={this.coalesceProperty(FormSettings.CONFIRMATION_LINK, '')}
						confirmationMessage={this.coalesceProperty(FormSettings.CONFIRMATION_MESSAGE, formCollectsSignature ? EmailMessages.SUBMISSION_RESPONSE_SIGNATURE_CONFIRMATION_MESSAGE : EmailMessages.CONFIRMATION_MESSAGE)}
						showSubmitAnotherResponseLink={this.coalesceProperty(FormSettings.SHOW_SUBMIT_ANOTHER_RESPONSE_LINK)}
						showEditResponseLink={this.coalesceProperty(FormSettings.SHOW_EDIT_RESPONSE_LINK)}
						showResponseSummary={this.coalesceProperty(FormSettings.SHOW_RESPONSE_SUMMARY)}
						localization={localization}
                        formCollectsPayment={formCollectsPayment}
						formCollectsSignature={formCollectsSignature}
					/>
				</div>
			</section>
		);
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/advanced-settings/components/tabs/public-form.js